// extracted by mini-css-extract-plugin
export default {"mainContainer":"sendFileModal_mainContainer__DLcna","warningMessage":"sendFileModal_warningMessage__NvR0D"};